<template>
  <section>
    <!--工具条-->
    <toolbar
      :buttonList="buttonList"
      @callFunction="callFunction"
    ></toolbar>

    <el-main :style="defaultHeight">
      <!--列表-->
      <el-table
        :data="listData"
        highlight-current-row
        @current-change="selectCurrentRow"
        v-loading="listLoading"
        @selection-change="selsChange"
        @row-dblclick="handleEdit"
        style="width: 100%;"
      >
        <el-table-column
          type="index"
          width="80"
        >
        </el-table-column>
        <el-table-column
          prop="BillNo"
          label="报销单号"
          width=""
          sortable
        >
        </el-table-column>

        <el-table-column
          prop="Amount"
          label="金额"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="IsDG"
          label="是否对公"
          :formatter="formatIsDG"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建日期"
          :formatter="formatDate"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="CreateBy"
          label="创建人"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="StatusName"
          label="状态"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="pz"
          label="凭证信息"
          width=""
          sortable
        >
        </el-table-column>
      </el-table>
    </el-main>

    <!--工具条-->
    <el-col
      :span="24"
      class="toolbar"
    >
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="50"
        :total="total"
        style="float:right;"
      >
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-row
        type="flex"
        justify="space-between"
      >
        <el-col :span="2">
          <div>
            <el-button
              type="primary"
              @click="addreuser"
            >
              新增报销人
            </el-button>
          </div>
        </el-col>
        <el-col
          :span="6"
          v-if="false"
        >
          <div>
            <el-tag>{{Hwarning}}</el-tag>
          </div>
        </el-col>
      </el-row>

      <el-table
        :data="addForm.Entry"
        border
        style="width: 100%; margin-top: 20px"
      >

        <el-table-column
          prop="StaffID"
          label="报销人"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.StaffID"
              @change="userchange(scope.row)"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择报销人'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in users"
                :key="item.uID"
                :label="item.uLoginName"
                :value="item.uID"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="CostDepID"
          label="费用归属部门"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.CostDepID"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择部门'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in deps"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="Type"
          label="费用类型"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.CostTypeId"
              placeholder="请选择"
              @change="newgetbudget(scope.row)"
            >
              <el-option
                :key="0"
                :label="'未选择费用类型'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in costtypes"
                :key="item.Id"
                :label="item.CostTypeName"
                :value="item.Id"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="Subject"
          label="项目"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.Subject"
              placeholder="请选择"
            >
              <el-option
                :key="0"
                :label="'未选择项目'"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in subjects"
                :key="item.Number"
                :label="item.Name"
                :value="item.Number"
              ></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="出差天数"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.Amount"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="show"
          prop="Amount"
          type='number'
          label="标准(餐+住)"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="YSDATE"
          label="预算区间"
        >
          <template slot-scope="scope">
            <el-date-picker
              style="width:90%"
              v-model="scope.row.YSDATE"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              :picker-options="pickerOptions"
              @change="newgetbudget(scope.row)"
            >
            </el-date-picker>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="CurSurplus"
          label="剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="YearCurSurplus"
          label="年度剩余额度"
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          type='number'
          label="本次报销额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              @blur="checkAmount(scope.row)"
              ref="input"
            ></el-input>
            <!-- <el-input-number
              size='small'
              :controls='false'
              v-model="scope.row.Amount"
            ></el-input-number> -->
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteUser(scope.$index)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item
          label="报销人"
          prop="StaffID"
        >
          <el-select
            v-model="addForm.StaffID"
            placeholder="请选择报销人"
          >
            <el-option
              :key="0"
              :label="'未选择报销人'"
              :value="0"
            ></el-option>
            <el-option
              v-for="item in users"
              :key="item.uID"
              :label="item.uLoginName"
              :value="item.uID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="部门"
          prop="DepID"
        >
          <el-select
            v-model="addForm.DepID"
            placeholder="请选择部门"
          >
            <el-option
              :key="0"
              :label="'未选择部门'"
              :value="0"
            ></el-option>
            <el-option
              v-for="item in deps"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="费用类型"
          prop="Type"
        >
          <el-select
            v-model="addForm.Type"
            placeholder="请选择费用类型"
          >
            <el-option
              :key="0"
              :label="'未选择费用类型'"
              :value="0"
            ></el-option>
            <el-option
              v-for="item in costtypes"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="报销金额"
          prop="Amount"
        >
          <el-input
            v-model="addForm.Amount"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="本月预算"
          prop="CurBudget"
        >
          <el-input
            v-model="addForm.CurBudget"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="本月剩余"
          prop="CurSurplus"
        >
          <el-input
            v-model="addForm.CurSurplus"
            auto-complete="off"
          ></el-input>
        </el-form-item>

      </el-form> -->
      <el-row>
        <el-upload
          class="upload-demo"
          ref="add-upload"
          :action="UploadUrl()"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :file-list="fileList"
          :on-success="handlesuccess"
          multiple
          :auto-upload="false"
        >
          <el-button-group>
            <el-button
              type="primary"
              size="small"
            >选取文件</el-button>
            <el-button
              type="success"
              size="small"
              @click="submitUpload('add')"
            >上传到服务器</el-button>
          </el-button-group>
          <el-divider direction="vertical"></el-divider>
          <el-button
            size="small"
            type="primary"
            @click="addinvoice"
          >
            手工新增
          </el-button>
          <div
            slot="tip"
            class="el-upload__tip"
          >文件名中不可含有特殊符号且单个文件不能超过4M</div>
        </el-upload>
        <!-- <el-table
        :data="InvoiceInfo"
        highlight-current-row
        style="width: 100%;"
      >

        <el-table-column
          prop="InvoiceNo"
          label="发票号"
          width="120"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="Amount"
          label="发票金额"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="TaxpayerNo"
          label="纳税人识别号"
          width=""
          sortable
        >
        </el-table-column>
      </el-table> -->
      </el-row>
      <el-table
        :data="addForm.EntryInvoiceinfo"
        border
        style="width: 100%; margin-top: 20px;"
      >

        <el-table-column
          prop="InvoiceName"
          label="发票名称"
          width="180"
        >

        </el-table-column>
        <el-table-column
          prop="InvoiceNo"
          label="发票号码"
          width="180"
        >
        </el-table-column>
        <el-table-column
          prop="ItemName"
          label="项目名称"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.ItemName"
              :disabled="scope.row.Type!=99"
            ></el-input>
          </template>
        </el-table-column>

        <el-table-column
          :formatter="formatData"
          prop="InvoiceDate"
          label="开票日期"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.InvoiceDate"
              align="right"
              style="width:90%"
              type="date"
              :disabled="scope.row.Type!=99"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </template>

        </el-table-column>
        <el-table-column
          prop="Amount"
          label="金额"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Amount"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          prop="Count"
          label="张数"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.Count"
              :disabled="scope.row.Type!=99"
              @blur="getfpsum($event)"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="发票状态"
          width="180"
        >
          <template slot-scope="scope">
            <div
              slot="reference"
              class="name-wrapper"
            >
              <el-tag
                size="medium"
                :type="scope.row.Status === '0' ? 'success'  :scope.row.Status === '1' ? 'warning'  :'danger'"
              >{{ scope.row.StatusInfo }}</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
        >
          <template slot-scope="scope">
            <el-button
              @click="deleteInvoice(scope.row)"
              type="text"
              size="small"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog
      title="查看"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @close='handleget'
      width="80%"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item>
              <div style="font-size:16px">发生“招待费”和“其他费用”时，列出何处发生，联系人姓名，职务，代表公司
                发生“差旅费”，列明出差事由。</div>
              <div style="font-size:16px">如有新项目，请写明。</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">

          <el-col :span="24">
            <el-form-item
              label="说明"
              prop="Remark"
            >
              <el-input
                :rows="4"
                type="textarea"
                v-model="editForm.Remark"
                auto-complete="off"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col :span="24">
            <el-form-item
              label="明细"
              prop="editForm.Entry.Entry"
            >
              <el-table
                :data="editForm.Entry"
                border
                style="width: 100%; margin-top: 20px"
              >
                <el-table-column
                  prop="CostName"
                  label="费用类型"
                >
                </el-table-column>
                <el-table-column
                  prop="RBDate"
                  :formatter="formatData"
                  label="报销日期"
                >
                </el-table-column>
                <el-table-column
                  prop="StaffName"
                  label="姓名"
                >
                </el-table-column>
                <el-table-column
                  prop="CostDepName"
                  label="部门"
                >
                </el-table-column>
                <el-table-column
                  prop="SubjectName"
                  label="项目"
                >
                </el-table-column>
                <el-table-column
                  prop="Amount"
                  label="总计"
                >
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <!-- <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
        >保存</el-button> -->
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from '../../../util/date'
import { testapi, Crevoucher, getListRBPage, getUserListPage, GetReimburseMentById, removeListRB, getRB, editListRB, SubmitRB, RecheckRB, batchRemoveUser, addRB, getDepListPage, getDictionaryListPage, getRBListPage, getCostTypeListPage, getbudget, checkRB, editRB, ReSubmitRB } from '../../api/api';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import printmb from "../../printer/mb/rbprinter";
import printmb2 from "../../printer/mb/2";
import { getLodop } from "../../printer/lodopFun";

export default {
  components: { Toolbar },
  data() {
    return {
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;
        }
      },
      filters: {
        name: ''
      },
      defaultHeight: {
        height: ""
      },
      Hwarning: '',
      fileList: [],
      huanjing: '',
      users: [],
      show: false,
      listData: [],
      reuser: [],
      deps: [],
      subjects: [],
      costtypes: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      page: 1,
      listLoading: false,
      sels: [],//列表选中列
      UploadPath: '',
      testUploadPath: '',
      DownPath: '',
      testDownPath: '',
      InvoiceInfo: [],
      addDialogFormVisible: false,
      editFormVisible: false,//编辑界面是否显示
      editLoading: false,
      editFormRules: {
      },
      //编辑界面数据
      editForm: {
        id: 0,
        uID: 0,
        RIDs: 0,
        uLoginName: '',
        uRealName: '',
        name: '',
        sex: -1,
        age: 0,
        birth: '',
        addr: '',
        Entry: {
          Entry: {

          }
        }
      },

      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addFormRules: {
      },
      //新增界面数据
      addForm: {
        Entry: {}
      }
      ,
      RBData: [],
      spanArr: [],
      spanArr2: []
    }
  },
  methods: {
    handleCrevoucher() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择需要生成凭证的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '2') {
        this.$message({
          message: "只有审核状态可生成！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认生成吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        Crevoucher(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '审核成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })

    },
    formatIsDG: function(row, column) {
      return row.IsDG ? '是' : '否';
    },
    getHeight() {
      this.defaultHeight.height = window.innerHeight - 250 + "px";
    },
    //获取列表
    handleget() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;
      testapi();
      getListRBPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.listData = res.data.response.data;
        this.listLoading = false;
      });
    },
    checkAmount(row) {
      var rows = [];
      rows.push(row);
      var msg = this.checkAmounts(rows);
      if (msg.length > 0) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: msg,
          type: "error"
        });
      }
    },
    checkAmounts(rows) {
      var message = '';
      rows.forEach(function(item) {
        if (item.Amount > item.CurSurplus) {
          message = '超额！请重输或与财务确认！' + '<br/>';
        }
        if (item.Amount < item.YearCurSurplus && item.Amount > item.CurSurplus) {
          message = '本月超额！请尝试次月报销或与财务确认！' + '<br/>';
        }
      });
      return message;
    },
    addreuser() {
      //控制只让选一种费用类型
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      if (tmp.Entry.length > 0) {
        var tmpCostType = tmp.Entry[0].CostTypeId;
        this.costtypes.forEach(function(item) {
          if (item.Id != tmpCostType) {
            item['disabled'] = true;
          }
        });
      }

      tmp.Entry.push({
        tmpid: 'tmp' + tmp.Entry.length,
        StaffID: '',
        DepID: '',
        CostTypeId: '',
        Amount: 0,
        CurBudget: '',
        CurSurplus: ''
      }
      );
    },
    deleteUser(index) {

      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      tmp.Entry.splice(index, 1);

      //解除控制只让选一种费用类型
      if (tmp.Entry.length == 1) {
        this.costtypes.forEach(function(item) {
          item['disabled'] = false;
        });
      }
    },
    addinvoice() {
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      tmp.EntryInvoiceinfo.splice(0, 0, {
        Status: '0',
        StatusInfo: '正确',
        InvoiceName: '手工新增',
        InvoiceDate: this.getNowFormatDate(),
        Count: 1,
        Type: 99,
        disabled: false,
        InvoiceNo: 'tmp' + tmp.EntryInvoiceinfo.length
      });
    },
    deleteInvoice(row) {

      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      const index = tmp.EntryInvoiceinfo.findIndex(a => a.InvoiceNo === row.InvoiceNo);
      tmp.EntryInvoiceinfo.splice(index, 1);
      const index2 = this.fileList.findIndex(text => text.name === row.FileName);
      this.fileList.splice(index2, 1);
      this.getfpsum();
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getfpsum() {
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      //删除原合计
      const index = tmp.EntryInvoiceinfo.findIndex(text => text.InvoiceName === '合计');
      if (index != -1) tmp.EntryInvoiceinfo.splice(index, 1);
      if (tmp.EntryInvoiceinfo.length > 0) {
        //求合计
        var s = 0;
        var z1 = '0';
        var z2 = '通过';
        tmp.EntryInvoiceinfo.forEach(function(val, idx, arr) {
          s += val.Amount;
          if (val.Status != '0' && val.Status != '1') {
            z1 = '2';
            z2 = '错误';
          }
        }, 0);

        //判断整体状态
        var heji = {
          InvoiceName: '合计',
          Amount: s,
          Status: z1,
          disabled: true,
          StatusInfo: z2,
          Type: 100
        };
        tmp.EntryInvoiceinfo.push(heji);
      }
    },
    userchange(row) {
      var depid = this.users.filter((user) => user.uID === row.StaffID)[0].DepID;
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
      tmp.Entry.forEach(function(item) {
        if (item.tmpid == row.tmpid) {
          item.DepID = depid;
          item.CostDepID = depid;
          item.Subject = '002';
          item.CurBudget = 0;
          item.CurSurplus = 0;
          item.CostTypeId = '';
        }
      });
    },
    //获取剩余额度
    newgetbudget(row) {
      var tmpload = this.$loading({
        lock: true,
        text: '正在计算剩余额度',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var tmp = this.editFormVisible == true ? this.editForm : this.addForm;

      //校验前置条件
      if (row.StaffID.length == 0) {
        this.$message({
          message: '请选择报销人后再选择费用类型',
          type: 'error'
        });

        tmp.Entry.forEach(function(item) {
          if (item.tmpid == row.tmpid) {
            item.CostTypeId = '';
          }
        });
        tmpload.close();
        return;
      }
      //先把额度置零
      tmp.Entry.forEach(function(item) {
        if (item.tmpid == row.tmpid) {
          item.CurBudget = 0;
          item.CurSurplus = 0;
        }
      });

      //转换部门编码,后端需要
      this.deps.forEach(function(item) {
        if (item.Id == row.CostDepID) {
          row.DepNo = item.Number;
        }
      });

      let para = row;
      getbudget(para).then((res) => {
        tmp.Entry.forEach(function(item) {
          if (item.tmpid == row.tmpid) {
            item.CurBudget = res.data.response.CurBudget;
            item.CurSurplus = res.data.response.CurSurplus;
            item.YearCurSurplus = res.data.response.YearCurSurplus;
          }
        })
      })
      tmpload.close();
    },
    getallbudget() {
      var tmpload = this.$loading({
        lock: true,
        text: '正在计算剩余额度',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      var _this = this;
      this.editForm.Entry.forEach(function(item) {
        item.CurBudget = 0;
        item.CurSurplus = 0;

        _this.deps.forEach(function(item2) {
          if (item2.Id == item.CostDepID) {
            item.DepNo = item2.Number;
          }
        });

        let para = item;
        getbudget(para).then((res) => {
          item.CurBudget = res.data.response.CurBudget;
          item.CurSurplus = res.data.response.CurSurplus;
          item.YearCurSurplus = res.data.response.YearCurSurplus;
        })
      });
      tmpload.close();
    },

    UploadUrl: function() {
      var UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;
      return UploadPath;
    },
    handlesuccess(response, file, fileList) {
      var tmpload = this.$loading({
        lock: true,
        text: '正在读取发票信息',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      if (response.success == true) {

        var tmp = this.editFormVisible == true ? this.editForm : this.addForm;
        //如果该发票不在明细内则加入
        if (tmp.EntryInvoiceinfo.filter((item, i) => {
          return item.InvoiceNo == response.response.InvoiceNo;
        }).length == 0) {
          tmp.EntryInvoiceinfo.push(response.response); //加到发票明细中
          fileList.find(a => a.name == file.name).name = response.response.FileName;//文件改名
          this.getfpsum();
        }
        else { //如果发票重复上传，自动删除
          const index = fileList.findIndex(text => text.name === file.name);
          fileList.splice(index, 1);
        }
      }
      else {
        this.$message({
          showClose: true,
          message: response.msg,
          type: 'error',
          duration: 0
        });
      }
      tmpload.close();
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
      // if (file.status == 'success') {
      //   var fileurl = this.huanjing == 'production' ? 'http://192.168.80.73:1003/api/File/DownFile/' : 'http://localhost:1003/api/File/DownFile/';
      //   let para = file.name;
      //   axios({
      //     // 用axios发送post请求
      //     method: "post",
      //     url: fileurl + "?filename=" + para, // 请求地址 ，也可以传递参数
      //     responseType: "blob" // 表明返回服务器返回的数据类型
      //   }).then((res) => {
      //     var content = res.data;
      //     var blob = new Blob([content]);
      //     var url = URL.createObjectURL(blob);
      //     let link = document.createElement('a')
      //     link.style.display = 'none'
      //     link.href = url
      //     link.setAttribute('download', file.name)
      //     document.body.appendChild(link)
      //     link.click()
      //   });
      // }
    },
    submitUpload(AddorEdit) {
      if (AddorEdit == 'edit') {
        this.$refs['edit-upload'].submit();
      }
      else if (AddorEdit == 'deal') {
        this.$refs['deal-upload'].submit();
      }
      else {
        this.$refs['add-upload'].submit();
      }
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search
      };
      this[item.Func].apply(this, item);
    },
    formatDate: function(row, column) {
      return (!row.CreateTime || row.CreateTime == '') ? '' : util.formatDate.format(new Date(row.CreateTime), 'yyyy-MM-dd hh:mm:ss');
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleget();
    },

    //获取用户列表
    getUsers() {
      getUserListPage().then((res) => {
        this.users = res.data.response.data;
      });
    },
    //获取部门列表
    getDeps() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getDepListPage(para).then((res) => {
        this.deps = res.data.response.data;
        this.listLoading = false;
      });
    },
    //获取项目
    getSubjects() {
      var filters = {
        name: 'SUBJECTS'
      };
      let para = {
        page: this.page,
        key: filters.name
      };
      this.listLoading = true;

      getDictionaryListPage(para).then((res) => {
        this.subjects = res.data.response.data[0].Entry;
        this.listLoading = false;
      });
    },
    //获取费用类型列表
    getCosts() {
      let para = {
        page: this.page,
        key: this.filters.name
      };
      this.listLoading = true;

      getCostTypeListPage(para).then((res) => {
        this.costtypes = res.data.response.data;
        this.listLoading = false;
      });
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.fileList = [];
      this.addForm = {
        Amount: 0,
        YSDATE: '',
        Entry: [],
        EntryInvoiceinfo: []
      };
      this.addreuser();
    },
    //审核
    handCheck() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要审核的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '1') {
        this.$message({
          message: "只有提交状态可审核！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认审核吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        checkRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '审核成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //反审核
    handReCheck() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要反审核的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '2') {
        this.$message({
          message: "只有审核状态可反审核！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认反审核吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        RecheckRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '反审核成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //提交
    handleSubmit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要提交的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '0') {
        this.$message({
          message: "只有创建状态可提交！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        SubmitRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //反提交
    handleRSubmit() {

      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要反提交的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '1') {
        this.$message({
          message: "只有提交状态可反提交！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认反提交吗？', '提示', {}).then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        ReSubmitRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '反提交成功',
              type: 'success'
            });
            this.handleget();
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
        })
      })
    },
    //打印
    handlePrinter() {
      // let row = JSON.parse(JSON.stringify(this.currentRow))
      // let row = {};
      let row = this.currentRow;
      console.log(row)
      debugger;
      if (!row) {
        this.$message({
          message: "请选择一行数据！",
          type: "error"
        });
        return;
      }
      // if (row.Status != 1) {
      //   this.$message({
      //     message: "请先提交保存后再打印！",
      //     type: "error"
      //   });
      //   return;
      // }
      let para = row.Id;
      GetReimburseMentById(para).then((res) => {
        var tmp = { entry1: {}, entry2: {} };
        // tmp.IsDG =res.data.response.res.data.response;
        tmp.entry1 = res.data.response;
        tmp.entry2 = JSON.parse(JSON.stringify(row))
        printmb(tmp);
      });

      //printmb2(row);
      // 
      // let para = 52;
      // getRB(para).then((res) => {
      //   
      //   var a = res.data.response.data;
      // });
    },
    //编辑
    editSubmit: function() {
      this.$confirm('确认保存吗？', '提示', {}).then(() => {

        this.editLoading = true;
        var a = this.editForm;
        if (typeof this.editForm.Remark == "undefined" || this.editForm.Remark == null || this.editForm.Remark == "") {
          this.editLoading = false;
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: "请填写报销说明！",
            type: 'error',
            duration: 0
          });
          return;
        }
        let para = Object.assign({}, this.editForm);
        editListRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.editLoading = false;
            return;
          }
          if (res.data.success) {
            this.addLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.editFormVisible = false;
            this.handleget();
          }
          else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });

          }
        });
        this.editLoading = false;
      });
    },
    //新增
    addSubmit: function() {
      this.$confirm('确认提交吗？', '提示', {}).then(() => {
        this.addLoading = true;
        var msg = this.Verification(this.addForm);
        if (msg.length > 0) {
          this.addLoading = false;
          this.$message({
            dangerouslyUseHTMLString: true,
            showClose: true,
            message: msg,
            type: 'error',
            duration: 0
          });
          return;
        }
        let para = Object.assign({}, this.addForm);

        addRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.addLoading = false;
            return;
          }
          if (res.data.success) {
            this.addLoading = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            });
            this.addFormVisible = false;
            this.handleget();
          }
          else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });

          }
        });
      });
    },
    Verification(info) {

      var msg = '';
      //校验预算额度
      msg = this.checkAmounts(info.Entry);

      //校验
      if (info.Entry.length < 1) msg += "请选择报销人！<br/>";
      //校验
      if (info.EntryInvoiceinfo.length < 1) msg += "请上传发票！<br/>";

      var ispass = false;
      //校验
      info.Entry.forEach(function(item) {
        if (item.Amount == 0) ispass = true;
      });
      if (ispass) {
        msg += "报销金额不能为0<br/>";
        ispass = false
      }

      //发票信息校验
      info.EntryInvoiceinfo.forEach(function(item) {
        if (item.Status == '2') ispass = true;
      });
      if (ispass) {
        msg += "存在发票信息校验失败，请检查或删除该发票！<br/>";
      }
      return msg;
    },
    //删除
    handleDel() {

      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要撤销的一行数据！",
          type: "error"
        });
        return;
      }
      if (row.Status != '1') {
        this.$message({
          message: "只有提交状态可反提交！",
          type: "error"
        });
        return;
      }
      this.$confirm('确认撤销该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true;
        let para = { Id: row.Id };
        removeListRB(para).then((res) => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: '撤销成功',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error'
            });
          }
          this.handleget();
        });
      }).catch(() => {
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    formatData: function(row, column) {
      return (!row.RBDate || row.RBDate == '') ? '' : util.formatDate.format(new Date(row.RBDate), 'yyyy-MM-dd');
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getHeight);
    //一定记得在页面关闭前销毁监听的resize事件，不然多次刷新后页面会因为内存泄漏崩溃
  },
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.handleget();
    this.getUsers();
    this.getDeps();
    this.getCosts();
    this.getSubjects();
    this.addForm.Entry = [];

    this.huanjing = process.env.NODE_ENV;
    UploadPath = this.huanjing == 'production' ? global.UploadPath : global.testUploadPath;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  }
}

</script>

<style >
.el-input__inner {
  width: 80%;
}
</style>
